import { HStack, useMediaQuery, VStack } from "@chakra-ui/react";
import SunsetAngleButton from "./SunsetAngleButton";
import ColorModeButton from "./ColorModeButton";
import LightBulbButton from "./LightBulbButton";
import WarButton from "./WarButton";
import GlobeButton from "./GlobeButton";

export default function FooterLeft({
  showSunsetAngle,
  setShowSunsetAngle,
  showWar,
  setShowWar,
  showMap,
  setShowMap,
}) {
  const [isMobile] = useMediaQuery("(max-width: 575px)");

  if (isMobile) {
    return (
      <VStack spacing="12px">
        <HStack spacing="12px" justifyContent="start" w="100%">
          <SunsetAngleButton
            showSunsetAngle={showSunsetAngle}
            setShowSunsetAngle={setShowSunsetAngle}
          />
          <WarButton showWar={showWar} setShowWar={setShowWar} />
        </HStack>
        <HStack spacing="12px">
          <LightBulbButton />
          <GlobeButton showMap={showMap} setShowMap={setShowMap} />
        </HStack>
        <HStack spacing="12px" justifyContent="start" w="100%">
          <ColorModeButton />
        </HStack>
      </VStack>
    );
  } else {
    return (
      <HStack spacing="12px">
        <ColorModeButton />
        <LightBulbButton />
        <SunsetAngleButton
          showSunsetAngle={showSunsetAngle}
          setShowSunsetAngle={setShowSunsetAngle}
        />
        <WarButton showWar={showWar} setShowWar={setShowWar} />
        <GlobeButton showMap={showMap} setShowMap={setShowMap} d />
      </HStack>
    );
  }
}
